<template>
  <a href @click.prevent="doSort">
    <slot></slot>
    <i v-if="sort.by != property" class="fa fa-sort" aria-hidden="true"></i>
    <i v-if="sort.by == property && sort.direction == 'asc'" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
    <i v-if="sort.by == property && sort.direction == 'desc'" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
  </a>
</template>
<script>

export default {

    props: ['sort', 'property'],
    data() {
        return {};
    },
    methods: {
        doSort() {
            if (this.sort.by == this.property) {
                this.sort.direction = this.sort.direction == 'asc' ? 'desc' : 'asc';
            }
            else{
                this.sort.by = this.property;
                this.sort.direction = 'asc';
            }
            this.$emit('change', this.sort);
        }
    }

};
</script>



// WEBPACK FOOTER //
// resources/js/ui/SortLink.vue